export default (storeRoute) => ({
  content: "",
  loading: false,
  error: null,

  async submit() {
    this.error = null;
    this.loading = true;

    try {
      const response = await fetch(storeRoute, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content,
          Accept: "application/json",
        },
        body: JSON.stringify({
          content: this.content,
        }),
      });

      if (response.status === 422) {
        const data = await response.json();
        this.error = data.message;
        return;
      }

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Failed to send message");
      }

      const message = await response.json();

      this.error = null;
      this.content = "";

      this.$dispatch("message-created", message.data);
    } catch (error) {
      console.error("Error submitting message:", error);
      this.error = "An error occurred while sending your message.";
    } finally {
      this.loading = false;
    }
  },
});
